<div>
  <h1 class="text-2xl font-bold">
    {{ 'privacy.title' | translate }}
  </h1>

  <div class="w-full">
    <!-- terms of service & privacy policy urls (visible to all users) -->
    <div class="flex flex-col gap-6 mt-6">
      <rk-form-field>
        <div class="font-bold mb-1">
          {{ 'privacy.terms-of-service-url' | translate }}
        </div>
        <input
          type="url"
          [formControl]="termsOfServiceUrl"
          [placeholder]="'privacy.terms-of-service-url-placeholder' | translate"
        />
        @if (termsOfServiceUrl.invalid && termsOfServiceUrl.value) {
          <div class="form-error-message">
            {{ 'global.url-invalid' | translate }}
          </div>
        }
      </rk-form-field>

      <rk-form-field>
        <div class="font-bold mb-1">
          {{ 'privacy.privacy-policy-url' | translate }}
        </div>
        <input
          type="url"
          [formControl]="privacyPolicyUrl"
          [placeholder]="'privacy.privacy-policy-url-placeholder' | translate"
        />
        @if (privacyPolicyUrl.invalid && privacyPolicyUrl.value) {
          <div class="form-error-message">
            {{ 'global.url-invalid' | translate }}
          </div>
        }
      </rk-form-field>
    </div>

    <!-- didomi subsection (only visible to users with cmp option) -->
    @if (cmpIsAvailable$ | async) {
      <div class="mt-6">
        <!-- toggle -->
        <div class="flex justify-between items-center">
          <div class="font-bold">
            {{ 'privacy.option-toggle' | translate }}
          </div>
          <rk-switch
            [isChecked]="cmpOptionEnabled"
            (switched)="onCmpOptionToggle($event)"
          ></rk-switch>
        </div>
        <div class="mt-2">{{ 'privacy.description' | translate }}</div>

        <!-- didomi form fields -->
        <div
          class="flex flex-col gap-6 mt-6"
          [class.opacity-50]="!cmpOptionEnabled"
        >
          <rk-form-field>
            <div class="font-bold mb-1">
              {{ 'privacy.didomi-api-key' | translate }}
            </div>
            <input
              type="text"
              [formControl]="didomiApiKey"
              [readOnly]="!cmpOptionEnabled"
              [placeholder]="'privacy.didomi-api-key-placeholder' | translate"
            />
          </rk-form-field>

          <rk-form-field>
            <div class="font-bold mb-1">
              {{ 'privacy.didomi-notice-id' | translate }}
            </div>
            <input
              type="text"
              [formControl]="didomiNoticeId"
              [readOnly]="!cmpOptionEnabled"
              [placeholder]="'privacy.didomi-notice-id-placeholder' | translate"
            />
          </rk-form-field>
        </div>
      </div>
    }
  </div>
</div>

